import React from 'react'
import {coreButtonInputs, coreButtonPropTypes} from './cta.helper'
import {useDetermineRouteTypeAndUrl} from 'hec/hooks/useDetermineRouteTypeAndUrl'
import useFetchPageDataForCta from './useFetchPageDataForCta'
import {Button} from 'hec/components/cta'

const BuilderLinkWrapper = ({
    children,
    openInNewTab,
    attributes,
    clickFunction,
    scrollTargetId,
    isInternalLink,
    isRevShare,
    pageReference,
    queryParams,
    externalLinkReference,
    'data-testid': dataTestId
}) => {
    const {className: attrClassName, ...restAttributes} = attributes || {}
    const {
        pageRef,
        externalLinkRef,
        isLoading: isPageDataLoading,
        error: pageDataError
    } = useFetchPageDataForCta({
        isInternalLink,
        pageReference,
        externalLinkReference
    })

    const {routeType, url} = useDetermineRouteTypeAndUrl({
        clickFunction,
        isInternalLink,
        pageReference: pageRef,
        externalLinkReference: externalLinkRef
    })

    if (isPageDataLoading) {
        return null
    }

    if (pageDataError) {
        console.error('Error fetching page data for CTA: ', pageDataError)
        return null
    }

    return (
        <Button
            openInNewTab={openInNewTab}
            clickFunction={clickFunction}
            scrollTargetId={scrollTargetId}
            isRevShare={isRevShare}
            routeType={routeType}
            url={url}
            queryParams={queryParams}
            className={attrClassName}
            {...restAttributes}
            data-testid={dataTestId || 'linkWrapper-LinkWrapper'}
        >
            {children}
        </Button>
    )
}

BuilderLinkWrapper.propTypes = {
    ...coreButtonPropTypes
}

export {BuilderLinkWrapper}

export const LinkWrapperDefinition = {
    component: BuilderLinkWrapper,
    name: 'LinkWrapper',
    noWrap: true,
    canHaveChildren: true,
    image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/link.svg',
    defaultChildren: [
        {
            '@type': '@builder.io/sdk:Element',
            component: {
                name: 'Text',
                options: {text: 'Click me'}
            }
        }
    ],
    inputs: coreButtonInputs
}
